module.exports = __webpack_public_path__ + "static/media/lds-logo_th.a2f4b815.svg";